import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import de1 from '../Images/degal1.png';
import de2 from '../Images/degal2.png';
import de3 from '../Images/degal3.png';

import wie1 from '../Images/wie1.jpg';
import wie2 from '../Images/WIE2.png';

import spark1 from '../Images/spark1.png';
import spark2 from '../Images/spark2.jpg';
import spark4 from '../Images/spark4.jpg';
import spark5 from '../Images/spark5.jpg';

import ot1 from '../Images/ot1.png';
import ot2 from '../Images/ot2.png';
import ot3 from '../Images/ot3.png';
import ot4 from '../Images/ot4.png';
import ot5 from '../Images/ot5.png';
import ot6 from '../Images/ot6.png';
import ot7 from '../Images/ot7.png';
import ot8 from '../Images/ot8.png';
import ot9 from '../Images/ot9.png';

function Design() {
  const [currentImageIndex, setCurrentImageIndex] = useState({});
  const [activeTab, setActiveTab] = useState('designs');

  const designProjects = [
    {
      id: 'design1',
      title: 'D-egal (Digital legal) Mobile App Design',
      category: 'UI/UX Design',
      images: [de1, de2, de3],
      highlights: [
        'Law focussed and intuitive user interface design',
        'Main features in the navigation tab for optimized user flow',
        'Implemented Features as per our robust research',
        'Recieved Praises by multiple Legal experts'
      ],
      figmaLink: 'https://www.figma.com/your-design-link-1'
    },
    {
      id: 'design2',
      title: 'IEEE-WIE Design Head',
      category: 'Design',
      images: [wie1, wie2],
      highlights: [
        'Gave them thier uniqe Identity by creating a logo as per the IEEE-WIE guidelines',
        'Created 50+ Designs',
        'Rewarded as the best team of that tenure',
        'Helped in Creating UI of their website'
      ],
      figmaLink: 'https://www.figma.com/your-design-link-2'
    },
    {
      id: 'design3',
      title: 'Spark E-cell Social Media Head',
      category: 'Design',
      images: [spark5, spark1, spark2, spark4],
      highlights: [
        'Designed various Social Media Posts and Stories by keeping in mind their style guides',
        'Shot and Edited Various videos and reels during this tenure.',
        'Played a key role in completion of Flag ship event "BENNOVATE"',
        'Followers count increased from 500 to 1500 during my tenure',
      ],
      figmaLink: 'https://www.figma.com/your-design-link-3'
    },
    {
      id: 'design4',
      title: 'Other Misc. Stuff',
      category: 'Design',
      images: [ot1, ot2, ot3, ot4, ot5, ot6, ot7, ot8, ot9],
      highlights: [
        'Made a few Sketches during Covid pandemic',
        'Love creating designs when I\'m bored',
        'Curated and designed a lot of templates, posts and reels for various social media accounts',
        'Designed Logos for 5+ Businesses and brands',
      ],
      figmaLink: 'https://www.figma.com/your-design-link-4'
    }
  ];

  const nextImage = (projectId) => {
    const project = designProjects.find(p => p.id === projectId);
    const currentIndex = currentImageIndex[projectId] || 0;
    const nextIndex = (currentIndex + 1) % project.images.length;
    setCurrentImageIndex(prev => ({
      ...prev,
      [projectId]: nextIndex
    }));
  };

  const prevImage = (projectId) => {
    const project = designProjects.find(p => p.id === projectId);
    const currentIndex = currentImageIndex[projectId] || 0;
    const prevIndex = currentIndex === 0 ? project.images.length - 1 : currentIndex - 1;
    setCurrentImageIndex(prev => ({
      ...prev,
      [projectId]: prevIndex
    }));
  };

  const goToImage = (projectId, imageIndex) => {
    setCurrentImageIndex(prev => ({
      ...prev,
      [projectId]: imageIndex
    }));
  };

  const openFigmaLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const openBehanceProfile = () => {
    window.open('https://www.behance.net/your-profile', '_blank', 'noopener,noreferrer');
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (tab === 'behance') {
      openBehanceProfile();
    }
  };

  return (
    <div className="design">
      {/* Header */}
      <div className="design-header">
        <h1>Design Portfolio</h1>
      </div>

      {/* Tab Buttons */}
      <div className="design-tabs">
        <button 
          className={`tab-button ${activeTab === 'designs' ? 'active' : ''}`}
          onClick={() => handleTabChange('designs')}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="7" height="7"></rect>
            <rect x="14" y="3" width="7" height="7"></rect>
            <rect x="14" y="14" width="7" height="7"></rect>
            <rect x="3" y="14" width="7" height="7"></rect>
          </svg>
          Designs
        </button>
        <button 
          className={`tab-button ${activeTab === 'journey' ? 'active' : ''}`}
          onClick={() => handleTabChange('journey')}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
          </svg>
          Journey
        </button>
        <button 
          className="tab-button"
          onClick={() => handleTabChange('behance')}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M22 7h-7v-2h7v2zm1.726 10c-.442 1.297-2.029 3-5.101 3-3.074 0-5.564-1.729-5.564-5.675 0-3.91 2.325-5.92 5.466-5.92 3.082 0 4.964 1.782 5.375 4.426.078.506.109 1.188.095 2.14h-8.027c.13 3.211 3.483 3.312 4.588 2.029h3.168zm-7.686-4h4.965c-.105-1.547-1.136-2.219-2.477-2.219-1.466 0-2.277.768-2.488 2.219zm-9.574 6.988h-6.466v-14.967h6.953c5.476.081 5.58 5.444 2.72 6.906 3.461 1.26 3.577 8.061-3.207 8.061zm-3.466-8.988h3.584c2.508 0 2.906-3-.312-3h-3.272v3zm3.391 3h-3.391v3.016h3.341c3.055 0 2.868-3.016.05-3.016z"/>
          </svg>
          Behance
        </button>
      </div>

      {/* Content Area */}
      {activeTab === 'designs' && (
        <div className="design-projects">
          {designProjects.map((project) => {
            const currentIndex = currentImageIndex[project.id] || 0;
            return (
              <div key={project.id} className="design-project-tile">
                <div className="project-content">
                  {/* Image Carousel */}
                  <div className="project-carousel">
                    <div className="carousel-container">
                      <img 
                        src={project.images[currentIndex]} 
                        alt={`${project.title} - Image ${currentIndex + 1}`}
                        className="carousel-image"
                        loading="lazy"
                      />
                    </div>
                    
                    {project.images.length > 1 && (
                      <div className="carousel-controls">
                        <button 
                          className="carousel-btn"
                          onClick={() => prevImage(project.id)}
                        >
                          <ChevronLeft size={16} />
                        </button>
                        
                        <div className="carousel-indicators">
                          {project.images.map((_, index) => (
                            <button
                              key={index}
                              className={`carousel-dot ${index === currentIndex ? 'active' : ''}`}
                              onClick={() => goToImage(project.id, index)}
                            />
                          ))}
                        </div>
                        
                        <button 
                          className="carousel-btn"
                          onClick={() => nextImage(project.id)}
                        >
                          <ChevronRight size={16} />
                        </button>
                      </div>
                    )}
                    
                    <button 
                      className="carousel-view-button"
                      onClick={() => openFigmaLink(project.figmaLink)}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                        <polyline points="15 3 21 3 21 9"></polyline>
                        <line x1="10" y1="14" x2="21" y2="3"></line>
                      </svg>
                      View
                    </button>
                  </div>
                  
                  {/* Project Details */}
                  <div className="project-details">
                    <div className="project-category">
                      {project.category}
                    </div>
                    <h3 className="project-title">
                      {project.title}
                    </h3>
                    
                    <div className="project-highlights">
                      <h4>Key Highlights:</h4>
                      <ul className="highlights-list">
                        {project.highlights.map((highlight, index) => (
                          <li key={index}>
                            {highlight}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {activeTab === 'journey' && (
        <div className="journey-section">
          <div className="journey-content">
            <h2 className="journey-main-title">My Design Journey</h2>
            <p className="journey-subtitle">From Curiosity to Creativity</p>
            
            <div className="journey-timeline">
              {/* Phase 1 */}
              <div className="journey-phase">
                <div className="phase-marker">
                  <div className="phase-dot"></div>
                  <div className="phase-line"></div>
                </div>
                <div className="phase-content">
                  <h3 className="phase-title">When I was a kid (Before 2022)</h3>
                  <div className="phase-description">
                    <div className="phase-item">
                      <div className="phase-pointer"></div>
                      <p>Won drawing and handwriting competitions in Class 3 – early signs of creativity.</p>
                    </div>
                    <div className="phase-item">
                      <div className="phase-pointer"></div>
                      <p>Became Chief Editor of class magazine in Class 4.</p>
                    </div>
                    <div className="phase-item highlight-item">
                      <div className="phase-pointer highlight-pointer"></div>
                      <p><strong>BREAKTHROUGH MOMENT 1:</strong> During class 12th when everyone was building simple Python CLI Project, I made amazing CLI UI using Colorama and ASCII art – still used as a model Project to the juniors.</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Phase 2 */}
              <div className="journey-phase">
                <div className="phase-marker">
                  <div className="phase-dot"></div>
                  <div className="phase-line"></div>
                </div>
                <div className="phase-content">
                  <h3 className="phase-title">Early Explorer (Before 2025)</h3>
                  <div className="phase-description">
                    <div className="phase-item">
                      <div className="phase-pointer"></div>
                      <p>Designed and managed 2–3 Instagram theme pages; learned Canva and design basics.</p>
                    </div>
                    <div className="phase-item">
                      <div className="phase-pointer"></div>
                      <p>Design Head at IEEE WIE – team work praised by peers and seniors alike.</p>
                    </div>
                    <div className="phase-item">
                      <div className="phase-pointer"></div>
                      <p>Ranked 36/380+ teams in SIH solely because of prototype quality and research depth.</p>
                    </div>
                    <div className="phase-item">
                      <div className="phase-pointer"></div>
                      <p>Conducted UX surveys and built the frontend for project UniVerse.</p>
                    </div>
                    <div className="phase-item">
                      <div className="phase-pointer"></div>
                      <p>Social Media Head at SPARK E-Cell – led a new team to successful campaigns.</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Phase 3 */}
              <div className="journey-phase">
                <div className="phase-marker">
                  <div className="phase-dot final-dot"></div>
                </div>
                <div className="phase-content">
                  <h3 className="phase-title">UI/UX as a career? (June 2025 onwards)</h3>
                  <div className="phase-description">
                    <div className="phase-item highlight-item">
                      <div className="phase-pointer highlight-pointer"></div>
                      <p><strong>IKIGAI MOMENT:</strong> Applying for Juspay PE-Intern role made me realize I could combine logic and creativity and make career out of it – my "IKIGAI".</p>
                    </div>
                    <div className="phase-item">
                      <div className="phase-pointer"></div>
                      <p>Explored Figma deeply and completed multiple UI/UX-focused courses.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Design;